var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyinventoryIcone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M360,0H152v79.999h208V0z M344,64H168V16h176V64z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368,24 368,40 408,40 408,496 104,496 104,40 144,40 144,24 88,24 88,512 424,512 424,24  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 32,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 32,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376,464 136,464 136,72 144,72 144,56 120,56 120,480 392,480 392,56 368,56 368,72 376,72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.344,130.343 184,156.686 173.658,146.342 162.342,157.656 184,179.314 221.656,141.656  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 136,
    width: 56,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 168,
    width: 104,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 248,
    width: 56,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 280,
    width: 104,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 360,
    width: 56,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 392,
    width: 104,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,296h64v-64h-64V296z M176,248h32v32h-32V248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,408h64v-64h-64V408z M176,360h32v32h-32V360z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyinventoryIcone);
export default __webpack_public_path__ + "static/media/myinventory-icone.8e50d3c9e9babe1d631f0b4f41b85d4f.svg";
export { ForwardRef as ReactComponent };